import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LandingHeaderComponent } from './components/landing-header/landing-header.component';
import { LandingCallToActionComponent } from './components/landing-call-to-action/landing-call-to-action.component';
import { LandingFooterComponent } from './components/landing-footer/landing-footer.component';
import { LandingFaqsComponent } from './components/landing-faqs/landing-faqs.component';
import { CertificatedFilterComponent } from './components/certificated-filter/certificated-filter.component';
import { LandingSubscriptionStepsComponent } from './components/landing-subscription-steps/landing-subscription-steps.component';
import { LandingOpinionsComponent } from './components/landing-opinions/landing-opinions.component';
import { MatIconModule } from '@angular/material/icon';
import { StoreModule } from '@ngrx/store';
import * as fromLanding from '../landing/store/reducers/landing.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LandingEffects } from './store/effects/landing.effects';
import { ZipCodeFormComponent } from './components/zip-code-form/zip-code-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ViewProductPageComponent } from './pages/view-product-page/view-product-page.component';
import { PurchasePageComponent } from './pages/purchase-page/purchase-page.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { PostalCodeSelectorDialogComponent } from './components/postal-code-selector-dialog/postal-code-selector-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { VerazPageComponent } from './pages/veraz-page/veraz-page.component';
import { OurFiltersComponent } from './components/our-filters/our-filters.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { AboutUsPageComponent } from './pages/about-us-page/about-us-page.component';

@NgModule({
  declarations: [
    LandingHeaderComponent,
    LandingCallToActionComponent,
    LandingFooterComponent,
    LandingFaqsComponent,
    CertificatedFilterComponent,
    LandingSubscriptionStepsComponent,
    LandingOpinionsComponent,
    ZipCodeFormComponent,
    ProductCardComponent,
    PostalCodeSelectorDialogComponent,
    VerazPageComponent,
    OurFiltersComponent,
    AboutUsComponent,
    AboutUsPageComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatSnackBarModule,
    StoreModule.forFeature(fromLanding.landingFeatureKey, fromLanding.reducer),
    EffectsModule.forFeature([LandingEffects]),
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatCheckboxModule,
  ],
  exports: [
    LandingFooterComponent,
    LandingHeaderComponent,
    LandingFaqsComponent,
    CertificatedFilterComponent,
    LandingSubscriptionStepsComponent,
    LandingOpinionsComponent,
    ZipCodeFormComponent,
    OurFiltersComponent,
    AboutUsComponent,
    MatIconModule,
    MatCheckboxModule,
  ],
})
export class LandingModule {}
